import { webpORpng } from ".";
import { DEMO_CONFIG } from "../demo/demo.config";
const format = webpORpng || "webp"; // fallback if undefined

const baseUrl = DEMO_CONFIG.demoMode
  ? ""
  : process.env.REACT_APP_ASSETS_IMAGE_URL || "";
const baseUrls = baseUrl ? baseUrl : "";
export const urls = baseUrls
  ? [
      `${baseUrls}plane-anim.json`,
      `${baseUrls}parachute-red-anim.json`,
      `${baseUrls}parachute-gray-anim.json`,
      `${baseUrls}sun-like-bg.${format}`,
      `${baseUrls}propeller.${format}`,
      `${baseUrls}dot.${format}`,
    ]
  : [];
